import React from 'react';
import { IProps } from './types';
import SliderMobile from 'components/SliderMobile';
import _ from 'lodash';

const InnerPageCAds: React.FC<IProps> = (props) => {
  /**
   * @description 建立圖片區塊
  */
  const handleCreateImgs = (imgUrls: string[]) => {
    const pcSmallChilds = new Array(0);
    let pcLargeChild;

    const mobileChilds = new Array(0);
    _.forEach(imgUrls, (url: string, index: number) => {
      mobileChilds.push(
        <SliderMobile.Item key={index}>
          <span>
            <img src={url} alt="" />
          </span>
        </SliderMobile.Item>
      );

      if (index === 0) {
        pcLargeChild = (
          <div className="member-only__inner-page-c-ads-large-section" key={index}>
            <div className="member-only__inner-page-c-ads-banner-pc">
              <span>
                <img src={url} alt="" />
              </span>
            </div>
          </div>
        );
      } else {
        pcSmallChilds.push(
          <div className="member-only__inner-page-c-ads-banner-pc" key={index}>
            <span>
              <img src={url} alt="" />
            </span>
          </div>
        );
      }
    });

    const pcImgs = (
      <div className="member-only__inner-page-c-ads-container-pc">
        {pcLargeChild}
        <div className="member-only__inner-page-c-ads-small-section">
          {pcSmallChilds}
        </div>
      </div>
    );

    const mobileImgs = (
      <div className="member-only__inner-page-c-ads-container-mobile">
        <SliderMobile
          name="inner-page-b-ads-mobile-slider"
          config={{ loop: true }}
          pagination
        >
          {mobileChilds}
        </SliderMobile>
      </div>
    );

    return (
      <>
        {pcImgs}
        {mobileImgs}
      </>
    );
  };

  return props.imgUrls && props.imgUrls.length > 0 ? (
    <div className="member-only__inner-page-c-ads">
      {handleCreateImgs(props.imgUrls)}
    </div>
  ) : null;
};

export default InnerPageCAds;
